var map = {
	"./Black_Account_Icons-01.png": 675,
	"./Black_Account_Icons-02.png": 676,
	"./Black_Account_Icons-03.png": 677,
	"./Black_Account_Icons-04.png": 678,
	"./Black_Account_Icons-05.png": 679,
	"./Black_Account_Icons-06.png": 680,
	"./Black_Account_Icons-07.png": 681,
	"./Black_Account_Icons-08.png": 682,
	"./Black_Account_Icons-09.png": 683,
	"./Black_Account_Icons-10.png": 684,
	"./Black_Account_Icons-11.png": 685,
	"./Black_Account_Icons-12.png": 686,
	"./Black_Account_Icons-13.png": 687,
	"./Black_Account_Icons-14.png": 688,
	"./FilePresentOutlined.svg": 689,
	"./accuracyAccountsDemo_downloadMT4.jpg": 690,
	"./accuracyAccountsReal_downloadMT4.jpg": 691,
	"./alert@2x.svg": 692,
	"./apple-brands.svg": 693,
	"./arrow_up_from_box.svg": 694,
	"./bankWire.svg": 695,
	"./bdswissDemo_downloadMT4.png": 696,
	"./bdswissGlobalDemo_downloadMT4.png": 697,
	"./bdswissGlobalReal02_downloadMT4.png": 698,
	"./bdswissGlobalReal03_downloadMT4.png": 699,
	"./bdswissGlobalReal04_downloadMT4.png": 700,
	"./bdswissGlobalReal05_downloadMT4.png": 701,
	"./bdswissGlobalReal_downloadMT4.png": 702,
	"./bdswissGlobalReal_downloadMT5.png": 703,
	"./bdswissReal02_downloadMT4.png": 704,
	"./bdswissReal03_downloadMT4.png": 705,
	"./bdswissReal04_downloadMT4.png": 706,
	"./bdswissReal05_downloadMT4.png": 707,
	"./bdswissReal_downloadMT4.png": 708,
	"./bdswissReal_downloadMT5.png": 709,
	"./bdswissSCDemo_downloadMT4.png": 710,
	"./bdswissSCReal01_downloadMT4.png": 711,
	"./bdswissSCReal02_downloadMT4.png": 712,
	"./bdswissSCReal03_downloadMT4.png": 713,
	"./bdswissSCReal04_downloadMT4.png": 714,
	"./bdswissSCReal05_downloadMT4.png": 715,
	"./bdswiss_grey.png": 716,
	"./bdswiss_white.png": 717,
	"./bg-image-affiliate.png": 718,
	"./bitwallet-bdSwiss-dark.svg": 719,
	"./bitwallet-bdSwiss-light.svg": 720,
	"./bitwallet-swissMarkets-dark.svg": 721,
	"./bitwallet-swissMarkets-light.svg": 722,
	"./card.svg": 723,
	"./check_circle.png": 724,
	"./chf.png": 725,
	"./competitions.png": 726,
	"./complimentary@2x.svg": 727,
	"./control-radio-off.png": 728,
	"./control-radio-on.png": 729,
	"./crypto.svg": 730,
	"./cvv.svg": 731,
	"./deposit-card.svg": 732,
	"./diners.png": 733,
	"./dkk.png": 734,
	"./document-upload-failure-dark.png": 735,
	"./document-upload-failure-light.png": 736,
	"./document-upload-success-black.png": 737,
	"./document-upload-success-dark.png": 738,
	"./document-upload-success-light.png": 739,
	"./documents-empty-dark.png": 740,
	"./documents-empty-light.png": 741,
	"./downloadPdf-light.png": 742,
	"./downloadPdf.png": 743,
	"./dpWorldTourChampionship-dark.svg": 744,
	"./dpWorldTourChampionship-light.svg": 745,
	"./eWallet.svg": 746,
	"./eur.png": 747,
	"./exp-date.svg": 748,
	"./fees@2x.svg": 749,
	"./filterIcon.png": 750,
	"./gbp.png": 751,
	"./icon-add-account.svg": 446,
	"./icon-appstore@2x.png": 752,
	"./icon-arrow-right-dark.png": 753,
	"./icon-arrow-right-light.png": 754,
	"./icon-bank-wire.svg": 755,
	"./icon-checkbox.svg": 756,
	"./icon-close-dark.svg": 757,
	"./icon-close-light.svg": 758,
	"./icon-close.png": 759,
	"./icon-contact-callback@2x.png": 760,
	"./icon-contact-callback@2x.svg": 761,
	"./icon-contact-chat@2x.png": 447,
	"./icon-contact-chat@2x.svg": 448,
	"./icon-contact-email@2x.png": 762,
	"./icon-contact-email@2x.svg": 763,
	"./icon-contact-faqs@2x.png": 764,
	"./icon-contact-faqs@2x.svg": 765,
	"./icon-contact-oneOnOneSession@2x.png": 766,
	"./icon-contact-telegram@2x.png": 767,
	"./icon-contact-whatsapp@2x.png": 768,
	"./icon-crypto.svg": 769,
	"./icon-document.svg": 770,
	"./icon-facebook@2x.png": 771,
	"./icon-google-play@2x.png": 772,
	"./icon-notification.svg": 773,
	"./icon-profile-big.svg": 774,
	"./icon-profile.svg": 775,
	"./icon-spoa.svg": 776,
	"./icon-swapFree.svg": 777,
	"./icon-telegram@2x.png": 778,
	"./icon-twitter@2x.png": 779,
	"./icon_accounts_dashboard.svg": 780,
	"./icon_logout_dashboard.svg": 781,
	"./icon_notification_dashboard.svg": 782,
	"./icon_profilesettings_dashboard.svg": 783,
	"./icon_support_dashboard.svg": 784,
	"./icon_transaction_dashboard.svg": 785,
	"./jcb.png": 786,
	"./languages.png": 787,
	"./limit-failure-dark.png": 788,
	"./limit-failure-light.png": 789,
	"./logo-accuracy.png": 790,
	"./logo-bdstrading-white.svg": 791,
	"./logo-bdstrading.svg": 792,
	"./logo-bdswiss-white.svg": 793,
	"./logo-bdswiss.png": 794,
	"./logo-bdswiss.svg": 795,
	"./logo-equityflow-black.png": 796,
	"./logo-equityflow-white.png": 797,
	"./logo-facebook.png": 798,
	"./logo-google.png": 799,
	"./logo-lydian-black.png": 800,
	"./logo-lydian-black.svg": 801,
	"./logo-lydian-white.svg": 802,
	"./logo-regalx-white.png": 803,
	"./logo-regalx.png": 804,
	"./logo-skyground-black.svg": 805,
	"./logo-skyground-white.svg": 806,
	"./logo-swissmarkets-white.svg": 807,
	"./logo-swissmarkets.png": 808,
	"./logo-swissmarkets.svg": 809,
	"./logo-tauromarkets-black.png": 810,
	"./logo-tauromarkets-white.png": 811,
	"./logo-tauromarkets-white2.png": 812,
	"./logo-tauromarkets-white2.svg": 813,
	"./logo-valutamarkets.png": 814,
	"./lydian/login-bg.png": 1353,
	"./lydian/logo.svg": 1354,
	"./lydian/lydian-trading-academy-coming_soon.png": 1355,
	"./lydian/lydian-trading-academy.png": 1356,
	"./lydian/lydian-watermark.png": 471,
	"./lydian/trading-academy-logo.svg": 472,
	"./lydian/user-icon.svg": 1357,
	"./maestro.png": 815,
	"./mastercard.png": 816,
	"./mastercard_logo_icon.svg": 817,
	"./mercedesCup-dark.svg": 818,
	"./mercedesCup-light.svg": 819,
	"./mobile/accounts.svg": 1358,
	"./mobile/more.svg": 1359,
	"./mobile/notifications.svg": 1360,
	"./mobile/payments.svg": 1361,
	"./nationalIdBR.png": 820,
	"./nationalIdES.jpg": 821,
	"./nationalIdIT.jpg": 822,
	"./nationalIdZA.png": 823,
	"./no-trades-dark.png": 824,
	"./no-trades-light.png": 825,
	"./no-trading-signals-dark.png": 826,
	"./nok.png": 827,
	"./notifications-empty-dark.png": 828,
	"./notifications-empty-light.png": 829,
	"./onlineBanking.svg": 830,
	"./onlineDeposit.svg": 831,
	"./page-not-found-dark.svg": 449,
	"./page-not-found-light.svg": 450,
	"./payment-failure-dark.png": 832,
	"./payment-failure-light.png": 833,
	"./payment-pending-dark.png": 834,
	"./payment-pending-light.png": 835,
	"./payment-success-dark.png": 836,
	"./payment-success-light.png": 837,
	"./payments-history-empty-dark.png": 838,
	"./payments-history-empty-light.png": 839,
	"./phone_verification.png": 840,
	"./place1-leadership.png": 841,
	"./place2-leadership.png": 842,
	"./place3-leadership.png": 843,
	"./pln.png": 844,
	"./pof-bankStatement.png": 845,
	"./pof-bankStatementPOF.png": 846,
	"./pof-card-back.png": 847,
	"./pof-card.png": 848,
	"./pof-cardStatement.png": 849,
	"./pof-other.png": 850,
	"./pof-proofOfResidence.png": 851,
	"./pof-swiftCopyPaymentAdvice.png": 852,
	"./pof-virtualCard.png": 853,
	"./poi-document.png": 854,
	"./poi-drivingLicense-back.png": 855,
	"./poi-drivingLicense.png": 856,
	"./poi-id-back.png": 857,
	"./poi-id.png": 858,
	"./poi-passport.png": 859,
	"./por-bankStatementPOR.png": 860,
	"./por-document.png": 861,
	"./por-proofOfResidence.png": 862,
	"./por-utilityBill.png": 863,
	"./priority@2x.svg": 864,
	"./referAndEarn.png": 865,
	"./regalxDemo_downloadMT4.png": 866,
	"./regalxReal01_downloadMT4.png": 867,
	"./regalxReal02_downloadMT4.png": 868,
	"./regalxReal03_downloadMT4.png": 869,
	"./regalxReal04_downloadMT4.png": 870,
	"./regalxReal05_downloadMT4.png": 871,
	"./register-referral-light.png": 872,
	"./sek.png": 873,
	"./sign-up.png": 874,
	"./spaceship.png": 875,
	"./spreads@2x.svg": 876,
	"./support@2x.svg": 877,
	"./swissmarketsDemo_downloadMT4.png": 878,
	"./swissmarketsReal02_downloadMT4.png": 879,
	"./swissmarketsReal_downloadMT4.png": 880,
	"./tauroDemo01DownloadMT4.jpg": 881,
	"./tauroReal01DownloadMT4.jpg": 882,
	"./technicalIndicator-ebook.png": 883,
	"./technicalIndicatorItem.svg": 884,
	"./telegram-dark.png": 885,
	"./telegram.png": 886,
	"./trading-alerts-tradingAlerts-dark.png": 887,
	"./trading-alerts-tradingAlerts-light.png": 888,
	"./tradingPsychology-ebook.png": 889,
	"./tradingPsychologyItem.svg": 890,
	"./transfer-external.svg": 891,
	"./transfer-internal.svg": 892,
	"./transfer-spoa.svg": 893,
	"./unlockYourTradingPotentialBanner/education_desktop.webp": 599,
	"./unlockYourTradingPotentialBanner/education_mobile.webp": 600,
	"./upload-bankStatement-error.png": 894,
	"./upload-bankStatement-success.png": 895,
	"./upload-bankStatement.png": 896,
	"./upload-document-dark.png": 897,
	"./upload-document-light.png": 898,
	"./upload-generic-error.png": 899,
	"./upload-generic-success.png": 900,
	"./upload-generic.png": 901,
	"./upload-pof-back-card-error.png": 902,
	"./upload-pof-back-card-success.png": 903,
	"./upload-pof-back-card.png": 904,
	"./upload-pof-front-card-error.png": 905,
	"./upload-pof-front-card-success.png": 906,
	"./upload-pof-front-card.png": 907,
	"./upload-poi-back-drivingLicense-error.png": 908,
	"./upload-poi-back-drivingLicense-success.png": 909,
	"./upload-poi-back-drivingLicense.png": 910,
	"./upload-poi-back-error.png": 911,
	"./upload-poi-back-success.png": 912,
	"./upload-poi-back.png": 913,
	"./upload-poi-front-drivingLicense-error.png": 914,
	"./upload-poi-front-drivingLicense-success.png": 915,
	"./upload-poi-front-drivingLicense.png": 916,
	"./upload-poi-front-error.png": 917,
	"./upload-poi-front-success.png": 918,
	"./upload-poi-front.png": 919,
	"./upload-por-front-error.png": 920,
	"./upload-por-front-proofOfResidence-error.png": 921,
	"./upload-por-front-proofOfResidence-success.png": 922,
	"./upload-por-front-proofOfResidence.png": 923,
	"./upload-por-front-success.png": 924,
	"./upload-por-front-utilityBill-error.png": 925,
	"./upload-por-front-utilityBill-success.png": 926,
	"./upload-por-front-utilityBill.png": 927,
	"./upload-por-front.png": 928,
	"./usd.png": 929,
	"./visa.png": 930,
	"./visa_logo_icon.svg": 931,
	"./vps-enter-credentials.png": 932,
	"./vps-remote-desktop-windows.png": 933,
	"./vps-remote-desktop.png": 934,
	"./waiting-list-skip-dark.png": 935,
	"./waiting-list-skip.png": 936,
	"./windows-brands.svg": 937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 939;